<template>
  <div class="search">
    <div class="bg-container">
      <!-- <div class="top-container"></div>
      <div class="bottom-container"></div>
      <img src="@/assets/img/bg_container.jpg" alt class="bg-img" /> -->
      <img src="@/assets/img/bg_pc1.jpg" alt class="bg-img pc" />
      <img src="@/assets/img/bg_mb4.jpg" alt class="bg_mb mobile" />
      <!-- <div class="mb-bottom mobile">
        <img :src="login_pic" @click="onGoActivityClick" alt />
      </div> -->
    </div>
    <div class="main-container">
      <!-- <img src="@/assets/img/bg-rb.png" class="bg-rb" alt /> -->
      <div class="operateDiv">
        <div class="title">
          <span class="text">质保查询登录</span>
        </div>
        <div class="phone-container">
          <mt-field
            placeholder="手机"
            v-model="phone"
            type="tel"
            class="myinput"
          ></mt-field>
        </div>
        <div class="code-container">
          <mt-field placeholder="校验码" v-model="code" class="myinput">
            <div
              :class="['getCode', { disabled: isSendCode }]"
              @click="getCode"
            >
              {{ isSendCode ? `请${inval.count}s后重发` : "发送验证码短信" }}
            </div>
          </mt-field>
        </div>
        <div>
          <mt-button size="large" class="mybutton" @click.native="onSearchClick"
            >查询</mt-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "./api";
import { Toast } from "mint-ui";
export default {
  components: {},
  data() {
    return {
      phone: "",
      code: "",
      isSendCode: false,
      inval: {
        timer: null,
        time: 1000,
        count: 60
      }
    };
  },
  mounted() {
    if(localStorage.getItem('info_user')){
      let data = JSON.parse(localStorage.getItem('info_user'));
      API.add_user({ phone: data.phone,code:data.code },res=>{
        if(res.code==200){
          localStorage.setItem('info',JSON.stringify(res.data));
          Toast({
            message: res.msg,
            iconClass: "icon icon-success"
          });
          this.$router.push({
            name: "result"
          })
        } else {
          localStorage.removeItem('info_user')
        }
      });
    }
  },
  methods: {
    getCode() {
      if (this.phone) {
        if (!/^1[3456789]\d{9}$/.test(this.phone)) {
          Toast({
            message: "手机号码有误，请重填",
            iconClass: "icon icon-error"
          });
          return;
        }
        if (this.isSendCode) {
          return;
        }
        API.send_code(
          {
            phone: this.phone
          },
          (res) => {
            if (res.code == 200) {
              Toast({
                message: "短信发送成功，请留意收到的手机短信",
                iconClass: "icon icon-success"
              });
            } else {
              Toast({
                message: res.msg,
                iconClass: "icon icon-error"
              });
            }
          }

        );
        this.isSendCode = true;
        this.startInval();
      } else {
        Toast({
          message: "请输入手机号",
          iconClass: "icon icon-error"
        });
      }
    },
    startInval() {
      this.inval.timer && clearInterval(this.inval.timer);
      this.inval.count = 60;
      this.inval.timer = setInterval(() => {
        if (this.inval.count > 0) {
          this.inval.count--;
        } else {
          this.inval.timer && clearInterval(this.inval.timer);
          this.isSendCode = false;
        }
      }, 1000);
    },
    onSearchClick() {
      if (this.phone && this.code) {
              API.add_user({ phone: this.phone,code:this.code },res=>{
                if(res.code==200){
                  localStorage.setItem('info',JSON.stringify(res.data));
                  Toast({
                    message: res.msg,
                    iconClass: "icon icon-success"
                  });
                  localStorage.setItem('info_user',JSON.stringify({phone:this.phone,code:this.code}))
                  this.$router.push({
                    name: "result"
                  })
                } else {
                  localStorage.removeItem('info_user')
          Toast({
            message: res.msg,
            iconClass: "icon icon-error"
          });
        }
              });
      }
    },
    onGoActivityClick() {
      Toast({
        message: "请验证手机号",
        iconClass: "icon icon-error"
      });
      this.$router.push({
        name: "activity",
        params: {}
      });
    }
  }
};
</script>

<style scoped lang="scss">
.search {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.search .bg-container {
  width: 100%;
  height: 100%;
}
.search .bg-container .bg_mb {
  // width: 100%;
  // height: 100%;
}
.search .bg-container .mb-bottom {
  width: 100%;
  height: 4rem;
  position: absolute;
  left: 0;
  bottom: 0;
  img {
    width: 3.4rem;
    height: 3rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.search .main-container {
  position: absolute;
  overflow: hidden;
}
/* 上面的线隐藏 */
.search .mint-cell-wrapper {
  background-image: linear-gradient(180deg, #fff, #fff 0%, transparent 0%);
}
/* 输入框底边框样式 */
.search .mint-cell-wrapper {
  border-bottom: 0px solid rgba(207, 71, 80, 1);
}
/* 修改按钮按钮下的默认颜色 */
.search .mint-button::after {
  background-color: transparent;
}
/* 修改默认 butoon 的样式 达到和淘宝登录一样 */
.search .mint-button--default {
  background: -webkit-linear-gradient(
      left,
      rgba(207, 71, 80, 1),
      rgba(207, 71, 80, 1)
    )
    no-repeat;
  border-radius: 0.25rem;
  color: #fff;
  height: 0.48rem;
}
/* 同上 */
.search .mint-button--primary {
  border-radius: 0.25rem;
  height: 0.48rem;
  background-color: transparent;
  border: 1px solid rgba(207, 71, 80, 1);
  color: rgba(207, 71, 80, 1);
}
/* 修改默认弹框的样式，达到基本和淘宝的效果一样 */
.search .mint-msgbox {
  border-radius: 0.08rem;
  width: 70%;
}
/* 弹出框内容样式 */
.search .mint-msgbox-content {
  min-height: 0.5rem;
  font-size: 0.18rem;
}
/* 弹出内容居中 */
.search .mint-msgbox-message {
  line-height: 0.5rem;
}
/* 弹出框确定按钮样式 */
.search .mint-msgbox-btns {
  height: 0.6rem;
}
/* 弹出框确定按钮字体 */
.search .mint-msgbox-confirm {
  color: #f40;
}

@media screen and (min-width: 100px) and (max-width: 640px) {
  .search .pc {
    display: none !important;
  }
  .search .bg-container {
    display: -webkit-flex; /* Safari */
    display: flex;
    // background: red;
    flex-direction: column;
  }
  .search .bg-container .top-container {
    width: 7.5rem;
    height: 2rem;
    // background: red;
  }
  .search .bg-container .bottom-container {
    width: 7.5rem;
    flex-grow: 1;
    // background: black;
  }
  .search .main-container {
    left: 50%;
    top: 4rem;
    transform: translateX(-50%);
    background-image: linear-gradient(
      to top,
      rgb(189, 187, 187),
      rgba(138, 135, 135, 0.1)
    );

    border-radius: 0.1rem;
    padding: 0.3rem 0.5rem 0.3rem;
  }
  .search .main-container .bg-rb {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 2.67rem;
  }
  .search .main-container .operateDiv {
    width: 5rem;
  }
  .search .main-container .operateDiv .title {
    margin-left: 0.1rem;
    width: 4rem;
  }
  .search .main-container .operateDiv .title .text {
    font-size: 0.29rem;
    font-family: Microsoft YaHei;
    font-weight: 550;
    letter-spacing: 0.1rem;
    color: rgb(83, 81, 81);
    line-height: 0.2rem;
    opacity: 0.9;
  }
  .search .main-container .operateDiv .title img {
    width: 4rem;
    height: 0.06rem;
    margin-top: 0.11rem;
  }
  .search .main-container .operateDiv .phone-container,
  .search .main-container .operateDiv .code-container {
    width: 5rem;
    height: 26px;
    // border: 2px solid rgba(207, 71, 80, 1);
    background: #fff;
    box-shadow: 0px 1px 25px 0px rgba(192, 192, 192, 0.75);
    border-radius: 0.1rem;
    overflow: hidden;
  }
  .search .main-container .operateDiv .phone-container {
    margin-top: 0.24rem;
  }
  .search .main-container .operateDiv .code-container {
    margin-top: 0.24rem;
  }
  .mint-cell {
    height: 26px !important;
    min-height: 26px !important;
    font-size: 13px !important;
    color: #f40;
  }

  .mint-cell > .mint-cell-wrapper {
    font-size: 13px !important;
  }
  /* 获取短信验证码字体颜色 */
  .search .main-container .operateDiv .getCode {
    width: 1.86rem;
    height: 26px;

    // border-radius: 0.1rem;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgb(186, 184, 184);
    line-height: 26px;
    text-align: center;
    margin-right: -10px;
  }
  .search .main-container .operateDiv .getCode.disabled {
    // background: #ac9f9f;
  }
  .search .main-container .operateDiv .mybutton {
    margin-top: 0.28rem;
    height: 30px;
    font-size: 0.3rem;
    text-align: center;
    font-weight: 550;
    letter-spacing: 0.2rem;
    color: rgb(98, 95, 95);
    background: linear-gradient(0deg, rgb(179, 177, 177), rgb(232, 232, 231));
    // box-shadow: 0px 6px 20px 0px rgba(248, 167, 105, 0.75);
    border-radius: 28px;
  }
}
@media screen and (min-width: 641px) {
  .search .mobile {
    display: none !important;
  }
  .search .bg-container .top-container,
  .search .bg-container .bottom-container {
    display: none;
    overflow: hidden;
  }
  .search .bg-container .bg-img {
    // width: 100%;
    // height: 100%;
  }
  .search .main-container {
    left: 64%;
    top: 48%;
    transform: translate(-50%, -50%);
    background-image: linear-gradient(
      to top,
      rgb(97, 96, 96),
      rgba(244, 240, 240, 0.1)
    );
    box-shadow: 0px 1px 25px 0px rgba(192, 192, 192, 0.75);
    border-radius: 10px;
    padding: 20px 66px 36px 66px;
  }
  .search .main-container .bg-rb {
    position: absolute;
    right: 0;
    bottom: -50px;
    width: 281px;
  }
  .search .main-container .operateDiv {
    width: 350px;
  }
  .search .main-container .operateDiv .title {
    width: 100%;
  }
  .search .main-container .operateDiv .title .text {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
    line-height: 20px;
  }
  .search .main-container .operateDiv .title img {
    width: 100%;
    height: 5px;
    margin-top: 13px;
  }
  .search .main-container .operateDiv .phone-container,
  .search .main-container .operateDiv .code-container {
    width: 100%;
    height: 40px;
    background: #fff;
    // border: 2px solid rgba(207, 71, 80, 1);
    // border-radius: 10px;
    .myinput {
      width: 350px;
    }
  }
  .search .main-container .operateDiv .mint-cell {
    // border-radius: 10px;
    height: 40px;
    min-height: 40px !important;
  }
  .search .main-container .operateDiv .phone-container {
    margin-top: 32px;
  }
  .search .main-container .operateDiv .code-container {
    margin-top: 32px;
  }

  /* 获取短信验证码字体颜色 */
  .search .main-container .operateDiv .getCode {
    width: 150px;
    height: 40px;
    // background: rgba(207, 71, 80, 1);
    border-radius: 10px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    letter-spacing: 1px;
    color: rgb(186, 184, 184);
    line-height: 40px;
    margin-right: -10px;
    text-align: center;
    cursor: pointer;
  }
  .search .main-container .operateDiv .getCode.disabled {
    // background: #ac9f9f;
  }
  .search .main-container .operateDiv .mybutton {
    margin-top: 32px;
    height: 40px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: normal;
    letter-spacing: 10px;
    color: rgb(15, 14, 14);
    background: linear-gradient(0deg, rgb(179, 177, 177), rgb(232, 232, 231));
    // box-shadow: 0px 6px 20px 0px rgba(248, 167, 105, 0.75);
    border-radius: 28px;
    cursor: pointer;
  }
}
</style>
